import { render, staticRenderFns } from "./RandomBook.vue?vue&type=template&id=644bd072&"
import script from "./RandomBook.vue?vue&type=script&lang=js&"
export * from "./RandomBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports